/**
 * CallCard realtime types — ES module version of realtime handlers from CallCards.ts
 *
 * This file contains the type definitions for call card realtime update logic.
 * The actual realtime handler implementations remain in the legacy CallCards.ts
 * until the CallCard screen is fully migrated to React (Phase 6a+).
 *
 * React components can import these types to understand the realtime update contract.
 */

import type { CallCardData, CallCommentData } from '@/services/api-types';

// ── Realtime message types ───────────────────────────────────────────

export interface RealtimeCallCommentMessage {
  callCardId: number;
  id: number;
  entry: string;
  dateCreated: string;
  creatorName: string;
}

export interface RealtimeCallCardUpdateMessage {
  callCardId: number;
}

// ── Property change detection helpers ────────────────────────────────

export function updateDatePropertyChanges(
  latestObj: Record<string, any>,
  originalObj: Record<string, any>,
  currentObj: Record<string, any>,
  propName: string,
): boolean {
  const propVal = latestObj[propName];
  const originalPropVal = originalObj[propName];
  const propValTime = propVal === null ? null : new Date(propVal).getTime();
  const originalTime = originalPropVal === null ? null : new Date(originalPropVal).getTime();
  if (propValTime !== originalTime) {
    if (propValTime === null) {
      originalObj[propName] = null;
      currentObj[propName] = null;
    } else {
      originalObj[propName] = new Date(propVal);
      currentObj[propName] = new Date(propVal);
    }
    return true;
  }
  return false;
}

export function updatePrimitivePropertyChanges(
  latestObj: Record<string, any>,
  originalObj: Record<string, any>,
  currentObj: Record<string, any>,
  propName: string,
): boolean {
  const propVal = latestObj[propName];
  if (propVal !== originalObj[propName]) {
    originalObj[propName] = propVal;
    currentObj[propName] = propVal;
    return true;
  }
  return false;
}
